import React from "react";

export default function Footer() {
  return (
    <footer
      style={{ backgroundColor: "#103D4B" }}
      className="text-white px-6 py-4 mt-auto"
    >
      <div className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-center justify-between text-sm">
        <div className="mb-2 sm:mb-0">
          &copy; 2025 IDCVS. All rights reserved.
        </div>

        {/* <div className="flex space-x-4">
          <a href="https://www.ets.org/legal/privacy.html" className="hover:underline">
            Privacy Policy
          </a>
          <a href="https://www.ets.org/legal/terms.html" className="hover:underline">
            Terms of Use
          </a>
          <a href="https://www.ets.org/epn_directory.html" className="hover:underline">
            Contact
          </a>
        </div> */}

        <div className="flex space-x-4">
          <a 
            href="https://www.ets.org/legal/privacy.html" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Privacy Policy
          </a>
          <a 
            href="https://www.ets.org/legal/terms.html" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Terms of Use
          </a>
          <a 
            href="https://www.ets.org/epn_directory.html" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
